"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptionStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const constants_1 = require("../../theme/constants");
exports.DescriptionStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  justify-content: stretch;
  width: 100%;

  @media (min-width: ${constants_1.sizes.tablet}) {
    gap: 1.5em;
  }

  @media (max-width: ${constants_1.sizes.tablet}) {
    gap: 3em;
  }

  h2 {
    display: flex;
    flex-flow: row nowrap;
    gap: 1em;
    align-items: center;
    justify-content: space-between;
    margin: 1em 0 0;
    font-weight: 600;

    @media (min-width: ${constants_1.sizes.tablet}) {
      flex-flow: row nowrap;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      flex-flow: column nowrap;
    }

    > span {
      font-size: 1.5em;
    }
  }

  >.description-content {
    display: flex;
    flex: 1;
    flex-flow: column nowrap;
    gap: 1.5em;
    align-items: stretch;
    justify-content: stretch;

    &.missing {
      color: ${design_system_1.theme.colors.marine[70]};
    }
  }

  >.description-controls {
    display: flex;
    gap: 1em;
    width: 100%;

    @media (min-width: ${constants_1.sizes.tablet}) {
      flex-flow: row nowrap;
      align-items: stretch;
      justify-content: flex-end;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
    }
  }
}
`;
//# sourceMappingURL=Description.styled.js.map